export default {"src":"/uk/_next/static/media/pensionbeeLogo.5002ac90.svg","height":105,"width":320,"blurWidth":0,"blurHeight":0};